import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProspectsIcon } from '../../assets';
import { PERMISSIONS } from '../../config/constants';
import { usePermissions } from '../../hooks/usePermissions';
import { Button } from '../common/Button';
import { ProspectPopUp } from './ProspectPopUp';

export const CreateProspect = ({ refetch }: { refetch: any }) => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const { checkPermission } = usePermissions();

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        id="createProspect"
        style="light-blue"
        text={t('prospects.createProspect')}
        iconLeft={<ProspectsIcon />}
        customClassnames={`${!checkPermission(PERMISSIONS.CREATE_PROSPECT) && 'hidden'}`}
      />
      {open && <ProspectPopUp setOpen={setOpen} refetch={refetch} />}
    </>
  );
};
